export class Pathologique {
	isEnRapportAvecALD: boolean;
	isEnRapportAvecGrossesse: boolean;

	constructor(
		isEnRapportAvecALD: boolean = false,
		isEnRapportAvecGrossesse: boolean = false
	) {
		this.isEnRapportAvecALD = isEnRapportAvecALD;
		this.isEnRapportAvecGrossesse = isEnRapportAvecGrossesse;
	}
}

export interface PathologiqueState {
	pathologique?: Pathologique;
}
